import React, {
    useEffect,
    useState,
  } from 'react';
  import moment from 'moment';
  import {useTranslation} from "react-i18next";
  import Pagination from '@mui/material/Pagination';
  import styles from './Requests.module.scss';
  import OutlinedInput from "@mui/material/OutlinedInput";
  import InputAdornment from "@mui/material/InputAdornment";
  import SearchIcon from '@mui/icons-material/Search';
  import {useDebouncedCallback} from "use-debounce";
  import {TailSpin} from 'react-loader-spinner';
  import {dateRangeOption, statusMap, statusOption} from '../../constants/helper';
  import {getDateFromRange} from '../../Helper/generalHelper';
  import NoTransaction from './../../assets/images/noTransaction.svg';
  import {useSelector} from 'react-redux';
  import {haveSegmentPermission} from '../../features/util';
  import MenuItem from "@mui/material/MenuItem";
  import Select from '@mui/material/Select';
  import {getCurrencyLabel} from '../../constants/currencies';
  import FilterIcon from './../../assets/images/filter_icon.svg';
  import ClickAwayListener from '@mui/material/ClickAwayListener';
  import CheckIcon from '@mui/icons-material/Check';
  import Chip from '@mui/material/Chip';
  import ClearIcon from '@mui/icons-material/Clear';
  import {makeStyles} from "@mui/styles";
  import useRequest from '../../API/request';
  import {getConfig} from '../../features/stores/config.slice';
  import DateRangePicker from '../../components/DateRangePicker';
  import RequestTable from '../../components/RequestTable';
  import TaskCompleteModal from '../../components/TaskCompleteModal';

  const useStyles = makeStyles(() => ({
    root: {
      'display': "flex",
      'flexWrap': "wrap",
      "& .MuiChip-deleteIcon": {
        'marginRight': "10px", // Change those values to yours
        'marginLeft': "10px", // Change those values to yours
      },
    },
  }));
  
  const Requests = () => {
    const {t} = useTranslation();
    const classes = useStyles();
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    const [size, setSize] = useState(12);
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('createdAt-DESC');
    const [dates, setDates] = useState<any>([moment(getDateFromRange(dateRangeOption[0])[0]), moment(getDateFromRange(dateRangeOption[0])[1])]);
    const [requestList, setRequestList] = useState<any>([]);
    const [orderStatusCount, setOrderStatusCount] = useState<any>([]);
    const [metaRecord, setMetaRecord] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [customRange, setCustomRange] = useState(dateRangeOption[0]);
    const [openTaskCompleteModal, setOpenTaskCompleteModal] = useState(false);
    const [taskIDObj, setTaskIDObj] = useState({taskID: '', type: ''});
    const [filter, setFilter] = useState<any>([]);
    const [openProofModal, setOpenProofModal] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [modalObj, setModalObj] = useState({attachmentUrl: '', comments: ''});
    const getDashboardRequest = useRequest({method: 'GET', url: '/finance/api/orders/dashboard', isShortUrl: true});
    const getMetaRequest = useRequest({method: 'GET', url: '/finance/api/orders/dashboard/summary', isShortUrl: true});
    const config = useSelector(getConfig).data || [];
    const currencyMap = haveSegmentPermission(config, 'currencyFactor') || [];

    const updatePagination = (event: React.ChangeEvent<unknown>, value: number) => {
      setCurrent(value);
    };

    const updatePaginationSize = (event: React.ChangeEvent<any>) => {
      setCurrent(1);
      setSize(event?.target?.value);
    };

    const handleSearch = useDebouncedCallback((e: any) => {
        fetchTransactions();
      }, 1000);

    const disabledDate = (current: any) => {
      return current && moment(current, 'YYYY-MM-DD').isAfter(moment().add(1, 'd').format('YYYY-MM-DD'));
    };

    const onCalendarChange = (dates: any, dateStrings: [string, string], info: any) => {
      if (dateStrings[0].length && dateStrings[1].length) {
        setDates(dateStrings);
      };
    };

    const handleCustomRange = (range: any) => {
      if (range?.target.value == "Custom") {
        setCustomRange('Custom');
        setDates([moment(dates[0]), moment(dates[1])]);
      } else {
        const [start, end] = getDateFromRange(range?.target?.value);
        setCustomRange(range?.target?.value);
        setDates([start, end]);
      }
    };

    const fetchMeta = async () => {
        try {
          setLoading(true);
          const params = {
            startDate: moment(`${moment(dates[0]).format('YYYY-MM-DD')} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(`${moment(dates[1]).format('YYYY-MM-DD')} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss'),
            productType: 'Media Kit',
          };
          const result = await getMetaRequest.doRequest(params);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log('Something went wrong!');
        }
      };

    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const params = {
          start: (current - 1) * size,
          limit: size,
          sortField: sort.split('-')[0],
          sortOrder: sort.split('-')[1],
          startDate: moment(`${moment(dates[0]).format('YYYY-MM-DD')} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(`${moment(dates[1]).format('YYYY-MM-DD')} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss'),
          search: search ? search : undefined,
          filters: {
            status: filter?.length ? filter : undefined,
          },
          productType: 'Media Kit',
        };
        const result = await getDashboardRequest.doRequest(params);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log('Something went wrong!');
      }
    };

    const updateFilter = (value: string) => {
      if (filter.includes(value)) {
        setFilter(filter.filter((e: string) => e != value));
      } else {
        setFilter([...filter, value]);
      }
    };

    const getEarnedAmount = (currency = ['usd', 'aed']) => {
      const earnedArr = [];
      for (let i = 0; i < currency.length; i++) {
        const amountEarned = (Array.isArray(metaRecord?.amountEarned) ? metaRecord?.amountEarned?.filter((ele: any) => ele?.currency?.toLowerCase() == currency[i])[0]?.total : metaRecord?.amountEarned) || 0;
        earnedArr.push(<div style={{minWidth: '50px'}}>{getCurrencyLabel(currency[i]) + ' ' + amountEarned/(currencyMap.filter((e: any) => e.currency == currency[i])[0]?.conversionFactor || 100) + (metaRecord?.amountEarned?.filter((cur: any) => cur.currency != 'sar')?.length > (i + 1) ? ' +' : '')}</div>);
      }
      return earnedArr.length ? earnedArr : '0';
    };

    useEffect(() => {
        if (getMetaRequest?.data) {
            setMetaRecord(getMetaRequest?.data);
        } else {
            setMetaRecord({});
        }
    }, [getMetaRequest.data]);

    useEffect(() => {
      if (getDashboardRequest?.data?.orders?.length) {
        setRequestList(getDashboardRequest?.data?.orders || []);
        setTotal(getDashboardRequest?.data?.totalCount);
        setOrderStatusCount(getDashboardRequest?.data?.ordersStatusCount || []);
      } else {
        setRequestList([]);
        setTotal(0);
        setOrderStatusCount(getDashboardRequest?.data?.ordersStatusCount || []);
      }
    }, [getDashboardRequest.data]);

    useEffect(() => {
        fetchTransactions();
    }, [dates, sort, size, current, filter]);

    useEffect(() => {
      fetchMeta();
    }, [dates]);
  
    return (
      <div className={styles.request_container}>
        {/* {openProofModal && <ProofModal handleClose={() => {
        setOpenProofModal(false);
        setModalObj({attachmentUrl: '', comments: ''});
        }} modalObj={modalObj} />} */}
        {openTaskCompleteModal && <TaskCompleteModal handleClose={(status?: any, attachmentUrl?: any, comments?: any) => {
          setOpenTaskCompleteModal(false);
          if (typeof status == 'string' && ['Completed', 'Accepted', 'Rejected'].includes(status)) {
            fetchTransactions();
          }
          setTaskIDObj({taskID: '', type: ''});
          }} taskIDObj={taskIDObj} />}
        <div className={styles.dashboard_body}>
        <div className={styles.heading_main}>
          <div className={styles.heading_title}>{t('request')}</div>
          <div className={styles.dateRange} id="date-range">
            <Select
              defaultValue={customRange}
              onChange={(e) => handleCustomRange(e)}
            >
              {dateRangeOption.map((e: any) => {
                return <MenuItem key={e} value={e}>{t(e)}</MenuItem>;
              })}
            </Select>
            {customRange == 'Custom' && <DateRangePicker start={dates[0]} end={dates[1]} onCalendarChange={onCalendarChange} />}
            </div>
        </div>
        <>
        <div className={styles.meta_wrapper}>
          <div className={styles.meta_container}>
              <div className={styles.single_meta}>
                  <div>
                    <div className={styles.heading}>{t('open_requests')}</div>
                    <div className={styles.amount}><div className={styles.light}>{t('request_in_24hrs')}:&nbsp;</div> <div>{metaRecord.lastDayCount || '0'}</div></div>
                  </div>
                  <div className={styles.count}>{orderStatusCount.filter((e: any) => e.status == 'In Review')?.[0]?.count || '0'}</div>
              </div>
              <div className={`${styles.single_meta} ${styles.middle}`}>
                  <div>
                    <div className={styles.heading}>{t('approved_requests')}</div>
                    {metaRecord?.latestAcceptedOrderDate && <div className={styles.amount}><div className={styles.light}>{t('last_request_on')} &nbsp;</div> <div>{moment(metaRecord.latestAcceptedOrderDate).format('DD MMM')}</div></div>}
                    {!metaRecord?.latestAcceptedOrderDate && <div className={styles.amount}><div className={styles.light}>{t('no_pending_request')}</div></div>}
                  </div>
                  <div className={styles.count}>{orderStatusCount.filter((e: any) => e.status == 'Accepted')?.[0]?.count || '0'}</div>
              </div>
              <div className={styles.single_meta}>
                  <div>
                    <div className={styles.heading}>{t('complete_requests')}</div>
                    <div className={styles.amount}><div className={styles.light}>{t('amount_earned')}:&nbsp;&nbsp;</div><div className={styles.amount_earned}>{getEarnedAmount() || '0'}</div></div>
                  </div>
                  <div className={styles.count}>{orderStatusCount.filter((e: any) => e.status == 'Completed')?.[0]?.count || '0'}</div>
              </div>
          </div> 
          </div> 
          <div className={styles.filter_container}>
            <div className={styles.filter_text}>{t('requests_filter')}</div>
            <div className={styles.search_container}>
              <div style={{width: '100%', position: 'relative'}}>
                <OutlinedInput
                  className={styles.search}
                  value={search}
                  onChange={(e: any) => {
                    setSearch(e.target.value);
                    handleSearch(e);
                  }}
                  startAdornment={<InputAdornment position="start"><SearchIcon></SearchIcon></InputAdornment>}
                  placeholder={t('search_for_request')}
                />
                <div className={styles.multifilter} onClick={() => setOpenFilter(!openFilter)}>
                  <img className={styles.icon} src={FilterIcon} onClick={() => {}} />
                </div>
                {openFilter && <ClickAwayListener onClickAway={() => setOpenFilter(false)}><div className={styles.multi_filter_container}>
                  {statusOption.map((ele: any) => {
                       return <MenuItem onClick={() => updateFilter(ele.value)} key={ele.value} value={`${ele.value}`}>
                          <div className={styles.option}><div>{ele.key}</div>{filter.includes(ele.value) && <div><CheckIcon /></div>}</div>
                         </MenuItem>;
                    })}
                </div></ClickAwayListener>}
              </div>
            </div>
          </div>
          {filter?.length ? <div className={`${styles.selected_filter} ${classes.root}`}>
            {filter.map((ele: string) => (
              <Chip key={ele} style={{color: 'black', backgroundColor: statusOption.filter((e: any) => e?.value == ele)[0].color}} label={ele} onDelete={() => updateFilter(ele)} color="primary" deleteIcon={<ClearIcon fontSize='small' style={{color: 'black'}} />} />
            ))}
          </div> : null}
          </>
        <div className={loading ? styles.loader : ''}>
          {loading ? <TailSpin color="#EB3B5A" height={80} width={80} /> : requestList.length ? <RequestTable requestList={requestList} sort={sort} setSort={setSort} setTaskIDObj={setTaskIDObj} setOpenTaskCompleteModal={setOpenTaskCompleteModal} setOpenProofModal={setOpenProofModal} setModalObj={setModalObj} /> :
          <div className={styles.noTransaction}>
            <img src={NoTransaction} />
            <div>{t('no_request_to_display')}</div>
          </div>}
        </div>
        {!!requestList.length && <div className={styles.pagination_container} id="pageSelector">
          <Select
            defaultValue={size}
            style={{
              width: '70px',
              height: '35px',
            }}
            onChange={(e: any) => updatePaginationSize(e)}
          >
             <MenuItem value={12}>12</MenuItem>
             <MenuItem value={20}>20</MenuItem>
             <MenuItem value={50}>50</MenuItem>
             <MenuItem value={100}>100</MenuItem>
          </Select>
          <Pagination
              onChange={updatePagination}
              size="small"
              count={Math.ceil(total/size)}
              defaultPage={current}
            />
        </div>}
        </div>
      </div>
    );
  };
  
  export default Requests;
